import {
  MobileSearchFrame,
  MobileSearchSideSlot,
} from "./mobile-search-frame";
import {
  MobileSearchBackButton,
  MobileSearchCameraIcon,
  MobileSearchClearButton,
} from "./mobile-search-overlay-controls";
import MobileSearchOverlayField from "./mobile-search-overlay-field";

const MobileSearchOverlayHeader = ({
  search,
  setSearch,
  inputRef,
  onClose,
  onSubmit,
  trimmedSearch,
  isPlayOverlay,
  isMainOverlay,
  hasEmbeddedSearchActions,
}) => {
  const handleClearOrClose = () => {
    if (search) {
      setSearch("");
      inputRef.current?.focus();
      return;
    }
    onClose();
  };

  return (
    <MobileSearchFrame
      as="form"
      useLayout={isMainOverlay}
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit(trimmedSearch);
      }}
      className={`sticky top-0 z-10 items-center border-b border-black/5 dark:border-white/10 ${
        isMainOverlay
          ? "bg-[#fbfbfc] px-3 py-3 dark:bg-custom_black"
          : isPlayOverlay
          ? "flex bg-[#fbfbfc] py-2 dark:bg-custom_black"
          : "flex bg-[#fbfbfc]/95 py-2 backdrop-blur-xl dark:bg-custom_black/95"
      } ${isMainOverlay ? "" : "gap-2 px-3"}`}
    >
      <MobileSearchBackButton
        isMainOverlay={isMainOverlay}
        isPlayOverlay={isPlayOverlay}
        onClose={onClose}
      />
      {!hasEmbeddedSearchActions && <MobileSearchCameraIcon />}
      <MobileSearchOverlayField
        search={search}
        setSearch={setSearch}
        inputRef={inputRef}
        isMainOverlay={isMainOverlay}
        isPlayOverlay={isPlayOverlay}
        hasEmbeddedSearchActions={hasEmbeddedSearchActions}
        onClearOrClose={handleClearOrClose}
      />
      {isMainOverlay && <MobileSearchSideSlot aria-hidden="true" />}
      {!hasEmbeddedSearchActions && (
        <MobileSearchClearButton onClick={handleClearOrClose} />
      )}
    </MobileSearchFrame>
  );
};

export default MobileSearchOverlayHeader;
